import ReactMarkdown from "react-markdown"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const Content = ({
  className,
  components,
  content,
  rehypePlugins,
  remarkPlugins,
  wrapperAs
}: ComponentProps) => (
  <Wrapper as={wrapperAs} className={className}>
    <ReactMarkdown
      components={components}
      rehypePlugins={rehypePlugins}
      remarkPlugins={remarkPlugins}
    >
      {content}
    </ReactMarkdown>
  </Wrapper>
)

export default Content
